import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getPageLayout = get('guest.components.pageLayout');

export const getSidebarNavExpanded = createSelector(
  getPageLayout,
  get('sidebarNavExpanded')
);
